<template>
  <v-dialog v-model="fullImageDialog" fullscreen>
    <v-card>
      <v-img :src="chosenAdvert.image" width="100%" height="100%" contain @click="closeDialog"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    chosenAdvert: {
      type:Object
    }
  },
  data(){
    return{
      item: {},
      fullImageDialog: false,
    }
  },
  methods: {
    openDialog(articledata) {
      this.item = articledata;
      this.fullImageDialog = true;
    },
    closeDialog(){
      this.fullImageDialog = false;
    }
  }
}
</script>